import { isNotNull } from '@hcr/utils'

import type { TicketsCount } from '../../hooks'

export const createTicketsTotalCount = (ticketsCount: TicketsCount | null, resortId: string): number =>
  isNotNull(ticketsCount) && ticketsCount[resortId] ? ticketsCount[resortId].singleTickets : 0
